import { templateActions } from "./actions";
import { ITemplateServer, ITemplatesMap, ITemplateState } from "./interface";

const templatesDataInitialState = {
  templateIds: [],
  totalTemplates: 0,
  totalPages: 0,
  pageNumber: 0,
};

const categoryTemplateInitialState = {
  BUSINESS:templatesDataInitialState,
  RESERVATION:templatesDataInitialState,
  BOOKING:templatesDataInitialState,
  LEAD_GENERATION:templatesDataInitialState,
  HUMAN_RESOURCES:templatesDataInitialState,
  REQUESTS:templatesDataInitialState,
  CONSTRUCTION:templatesDataInitialState,
  E_COMMERCE:templatesDataInitialState,
  NON_PROFIT:templatesDataInitialState,

}
export const initialState: ITemplateState = {
  templatesData: categoryTemplateInitialState,
  templatesMap: {},
  loaders: {
    fetchTemplates: false,
  },
  errors: {
    fetchTemplates: "",
  },
};
export const templatesReducer = (
  state: ITemplateState = initialState,
  action: { type: string; payload: any }
) => {

  switch (action.type) {
    case templateActions.FETCH_TEMPLATES: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchTemplates: true,
        },
        errors: {
          ...state.errors,
          fetchTemplates: "",
        },
      };
    }
    case templateActions.FETCH_TEMPLATES_SUCCESS: {

      const { content,pageNumber, totalElements, totalPages, category } = action.payload;
      return {
        ...state,
        templatesData: {
          ...state.templatesData,
          [category]:{
            content,
            totalTemplates: totalElements,
            totalPages: totalPages,
            pageNumber: pageNumber,
          }
        },
        loaders: {
          ...state.loaders,
          fetchTemplates: false,
        },
      };
    }
    case templateActions.FETCH_TEMPLATES_FAILED: {
      const error = action.payload.error;
      const pageNumber = action.payload.pageNumber;
      const category = action.payload.category;

      return {
        ...state,
        templatesData: {
          ...state.templatesData,
          templateIds: pageNumber > 1 ? (state.templatesData[category]?.templateIds || []) : [],
        },
        templatesMap: pageNumber > 1 ? state.templatesMap : {} ,
        loaders: {
          ...state.loaders,
          fetchTemplates: false,
        },
        errors: {
          ...state.errors,
          fetchTemplates: error,
        },
      };
    }
    default:
      return state;
  }
};
